<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="radioButtonValue"
	
	[label]="step3.getspan19"
	[type]="'radio'"
	[rule]="'pattern_29|required'"
	[errorMessage]="{'required' : 'ctr_1094'}"
	[radios]="[
		{
			label: step3.travaux,
			value: travauxValue
		},
		{
			label: step3.fournitures,
			value: fournituresValue
		},
		{
			label: step3.services,
			value: servicesValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>
